var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOkTick(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 143,
    height: 143,
    viewBox: "0 0 143 143",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8108",
    "data-name": "Grupo 8108",
    transform: "translate(-889 -370)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9813",
    "data-name": "Trazado 9813",
    d: "M-4415.145-16350.156l24.839,30.254,47.483-60.43",
    transform: "translate(5339.645 16791.832)",
    fill: "none",
    stroke: "#83d3d0",
    strokeLinecap: "round",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("g", {
    id: "Elipse_298",
    "data-name": "Elipse 298",
    transform: "translate(889 370)",
    fill: "none",
    stroke: "#83d3d0",
    strokeWidth: 8
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 71.5,
    cy: 71.5,
    r: 71.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 71.5,
    cy: 71.5,
    r: 67.5,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOkTick);
export default __webpack_public_path__ + "static/media/ok-tick.51bfc90997af9714cfffd237ad157518.svg";
export { ForwardRef as ReactComponent };